import React from 'react';
import { useParams } from 'react-router-dom';

import styled from '@emotion/styled';

import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateBin from '../../sections/dashboard/bins/CreateBin';
import CreateBinModal from '../../sections/dashboard/bins/CreateBinModal';

// import DeliveriesNotification from '../../sections/dashboard/racks/DeliveriesNotification';

const path = [
  {
    name: 'Rack List',
    link: '/',
  },
  {
    name: 'Bin List',
    link: '/bins',
  },
];

const Bins = () => {
  const { rackId } = useParams();

  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          {/* <DeliveriesNotification /> */}
          <BreadCrumbs pathData={path} />
          <CreateBin />
          <TableComponent
            tableBaseUrl={`warehouse-service/api/v1/bins`}
            // tableBaseUrl={`warehouse-service/api/v1/bins/${id}`}
            tblSearhURI="warehouse-service/api/v1/bins/search"
            tableExtraQueryParams={`rackId=${rackId}`}
            filterData={{
              'Bin Name': 'binName',
              Enabled: 'enabled',
              'Product Id': 'productId',
            }}
            tableHeader={[
              // 'binId',
              'binName',
              'rackName',
              'productId',
              'enabled',
              // 'lastUpdatedBy',
              'lastUpdatedDate',
            ]}
            mappingData={{
              // binId: 'Bin Id',
              binName: 'Bin Name',
              rackName: 'Rack Name',
              productId: 'Product Id',
              enabled: 'Enabled',
              // lastUpdatedBy: 'Updated By',
              lastUpdatedDate: 'Updated Date',
            }}
          />
        </Container>
        <Modal>
          <CreateBinModal />
        </Modal>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default Bins;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
